import {useBrandStore} from './brandStore';
import owlMarkUrl from '../../assets/brand/owl-mark.webp';
import wordmarkUrl from '../../assets/brand/wordmark.svg';

/**
 * Sorteia brand mark — the owner-supplied "glasses owl" logo.
 * Sourced directly from the master art: the owl was cropped out and its black
 * background keyed to transparency. Served through the Vite asset pipeline
 * (216px WebP, ~13KB vs the original 512px/130KB PNG) so the URL is
 * content-hashed and rides the origin's immutable /assets/* cache headers —
 * the logo downloads once, not on every visit.
 * `bold` is accepted for backwards-compat but no longer changes anything.
 */
export function BrandOwl({ size = 34, className }: { size?: number; bold?: boolean; className?: string }) {
  const configured = useBrandStore(state=>state.images.favicon?.url);
  return (
    <img
      src={configured||owlMarkUrl}
      width={size}
      height={size}
      alt="Sorteia"
      className={className}
      draggable={false}
      style={{ display: 'block', objectFit: 'contain' }}
    />
  );
}

/**
 * The "sorteia.com" wordmark — a crisp vector lockup (Comfortaa, OFL): white
 * "sorteia" with a cyan tittle on the i + gold ".com". Built to SVG paths so it
 * stays sharp at any size; imported through Vite for the same content-hashed
 * immutable caching as the owl mark. Set `height`; width scales to keep ratio.
 */
export function BrandWordmark({ height = 18, className }: { height?: number; className?: string }) {
  const configured = useBrandStore(state=>state.images.logo?.url);
  return (
    <img
      src={configured||wordmarkUrl}
      alt="sorteia.com"
      className={className}
      draggable={false}
      style={{ display: 'block', height, width: 'auto' }}
    />
  );
}
